import * as yup from 'yup'

import { 
    EMAIL_REGEX_FORMAT,
    trimmedInputValues,
} from '../utils';

const buyerInvoiceDetailSchema = yup.object().shape({
    buyerPhoneNumber: yup.string(),
        //.test('len', 'Must be exactly 10 characters', value => value.length === 10)
        //.required('Please enter phone no'),
    buyerEmailId: yup.string()
        .transform((value) => trimmedInputValues(value)),
        //.matches(EMAIL_REGEX_FORMAT, 'Please enter valid email')
        //.required('Please enter email'),
})

const uploadEWayBillSchema = yup.object().shape({
    ewayBillNo: yup.string()
        .transform((value) => trimmedInputValues(value))
        .test('ewayBillNoLength', 'Must be exactly 12 characters', value => value.length === 12)
        .required('Please enter the E-Way bill number'),
    ewayBillDate: yup.date().required('Please select E-way bill generated date'),
    // ewayBillFile
})

const uploadEWayBillInititalState = {
    ewayBillNo: null,
    ewayBillDate: null,
    ewayBillDoc: null
}

export { buyerInvoiceDetailSchema, uploadEWayBillSchema, uploadEWayBillInititalState }
